<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Cobertura
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialogForm = true">Nuevo</v-btn>
            <v-dialog v-model="dialogForm" :max-width="tamModal" :fullscreen="$root.isTouch"
                :scrollable="$root.isTouch == false" persistent>
                <coberturaModal :seleccionado="seleccionado" :tituloFormulario="tituloFormulario"
                    :listaGeneral="listaGeneral" :listaEstado="listaEstadoModal"></coberturaModal>
            </v-dialog>
        </v-card-title>
        <v-container>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Seguro *" color="textbox" v-model="objCoberturaFilter.seguroFiltro"
                        :items="listaGeneral.seguro" item-text="seguro" item-value="idSeguro" @change="listar"
                        outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Aseguradora *" color="textbox" v-model="objCoberturaFilter.aseguradoraFiltro"
                        :items="listaGeneral.aseguradora" item-text="aseguradora" item-value="idAseguradora"
                        @change="listar" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado" color="textbox" v-model="objCoberturaFilter.estadoFiltro"
                        :items="listaGeneral.estado" item-text="nombre_estado" item-value="id_estado" @change="listar"
                        outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6"/>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" prepend-inner-icon="search" v-model="buscar" dense/>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :headers="listaGeneral.cabecera" :items="listaGeneral.detalle" :search="buscar"
                        class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="editarItem(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-text="buscar"></span>" no arrojó resultados.                            
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

    export default {
        name:'CoberturaView',
        components: {
            coberturaModal: () => import('@/components/catalogo/ModalCoberturaComponent.vue')
        },
        provide: function () {
            return {
                insertarActualizar: this.insertarActualizar,
                cerrarFormulario: this.cerrarFormulario
            }
        },

        data() {
            return {
                buscar: '',
                objCoberturaFilter: {
                    seguroFiltro: null,
                    aseguradoraFiltro: null,
                    estadoFiltro: '1'
                },
                dialogForm: false,
                seleccionado: {},
                //Listas
                listaGeneral: {}
            }
        },
        beforeMount() {
            this.cargaGeneral();
        },
        computed: {
            tituloFormulario() {
                return (this.seleccionado.idCobertura == "0" || this.seleccionado.idCobertura == null) ?
                    'Nueva Cobertura' : 'Editar Cobertura'
            },
            listaEstadoModal() {
                var listadoEstadoModal = this.listaGeneral.estado;
                if (this.listaGeneral.estado) {
                    listadoEstadoModal = this.listaGeneral.estado.filter(estado => {
                        return estado.visualiza.toLowerCase().includes('true');
                    });
                    this.seleccionado.idEstado = (this.seleccionado.idCobertura == null) ? '1' : this.seleccionado
                        .idEstado;
                    this.seleccionado.idCobertura = (this.seleccionado.idCobertura == null) ? '0' : this.seleccionado
                        .idCobertura;
                }
                return listadoEstadoModal;
            }
        },

        methods: {
            cargaGeneral() {
                axios.post(`${BASE_URI}administrador/cobertura/cargaGeneral`, {
                        opcion: 'L'
                    })
                    .then((respuesta) => {
                        if (respuesta.status != '200') throw mensajeEstandar
                            .errorPeticion;
                        if (respuesta.data.existeError) throw respuesta.data.mensaje;

                        if (_.size(respuesta.data.data) > 0) {
                            this.listaGeneral = respuesta.data.data;
                            if (!_.isUndefined(this.listaGeneral.seguro[0].idSeguro)) {
                                this.objCoberturaFilter.seguroFiltro = this.listaGeneral.seguro[0].idSeguro;
                                this.listar('L');
                            }
                        } else
                            mensajesAlerta(respuesta.data.mensaje, 'I');

                    })
                    .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorPeticion, "E");
                    });
            },
            editarItem(item) {
                this.seleccionado = Object.assign({}, item),
                    this.dialogForm = true
            },
            cerrarFormulario() {
                this.dialogForm = false
                this.seleccionado = {}
            },
            tipoCondicionCambia() {
                this.coberturaFiltro = null
                this.listar();
            },
            listar(e) {
                if (!_.isUndefined(e)) {
                    this.$set(this.listaGeneral, 'detalle', []);
                    axios.post(`${BASE_URI}administrador/cobertura/listar`, {
                            opcion: 'L',
                            idAseguradora: this.objCoberturaFilter.aseguradoraFiltro,
                            idSeguro: this.objCoberturaFilter.seguroFiltro,
                            idEstado: this.objCoberturaFilter.estadoFiltro,
                        })
                        .then((respuesta) => {
                            if (respuesta.status != '200') throw mensajeEstandar
                                .errorPeticion;
                            if (respuesta.data.existeError) throw respuesta.data.mensaje;

                            if (_.size(respuesta.data.data) > 0)
                                this.$set(this.listaGeneral, 'detalle', respuesta.data.data);
                            else
                                mensajesAlerta(respuesta.data.mensaje, 'I');
                        })
                        .catch(function (er) {
                            mensajesAlerta(mensajeEstandar.errorPeticion, "E");
                        });
                }
            },

            insertarActualizar(_opcion) {
                axios.post(`${BASE_URI}administrador/cobertura/mantenimiento`, {
                        opcion: _opcion,
                        cobertura: this.seleccionado
                    })
                    .then((respuesta) => {
                        if (respuesta.status != '200') throw mensajeEstandar
                            .errorPeticion;
                        if (respuesta.data.existeError) throw respuesta.data.mensaje;
                        mensajeAlertaTiempo(respuesta.data.mensaje, "S");
                        this.listar('L');
                    })
                    .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                    });
            }
        }
    }
</script>